import Moselle1 from '../../../Media/Citraland Kedamaian/Moselle/Moselle (1).webp'
import Moselle2 from '../../../Media/Citraland Kedamaian/Moselle/Moselle (2).webp'
import Moselle3 from '../../../Media/Citraland Kedamaian/Moselle/Moselle (3).webp'
import Moselle4 from '../../../Media/Citraland Kedamaian/Moselle/Moselle (4).webp'
import Moselle5 from '../../../Media/Citraland Kedamaian/Moselle/Moselle (5).webp'
import Moselle6 from '../../../Media/Citraland Kedamaian/Moselle/Moselle (6).webp'
import Moselle7 from '../../../Media/Citraland Kedamaian/Moselle/Moselle (7).webp'
import Moselle8 from '../../../Media/Citraland Kedamaian/Moselle/Moselle (8).webp'
import Moselle9 from '../../../Media/Citraland Kedamaian/Moselle/Moselle (9).webp'
import Moselle10 from '../../../Media/Citraland Kedamaian/Moselle/Moselle (10).webp'


const Moselleimages =[
Moselle1,Moselle2,Moselle3,Moselle4,Moselle5,Moselle6,Moselle7,Moselle8,Moselle9,Moselle10
]

export default Moselleimages;